import { css } from '@linaria/core';
import { theming } from 'styles/utils';
export const searchInput = "omponents__ui_library__SearchInput__SearchInput_styles_ts-searchInput-swst34i";
export const searchInputWrapper = "omponents__ui_library__SearchInput__SearchInput_styles_ts-searchInputWrapper-s1e53nzr";
export const searchIconWrapper = "omponents__ui_library__SearchInput__SearchInput_styles_ts-searchIconWrapper-suxexgl";

require("./SearchInput.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./SearchInput.styles.ts");